module.exports = "<div class=cms-container layout=row layout-align=\"space-between top\"> <pre class=cms-formatted-text ng-if=$ctrl.cmsContentText>{{ $ctrl.cmsContentText }}</pre> <div ng-if=\"!$ctrl.cmsContentText && $ctrl.loggedIn\" user-permissions=\"['super_admin']\"><span translate>NO_CONTENT</span></div> <md-button class=\"md-icon-button cms-edit-button\" ng-click=$ctrl.onEditClick() user-permissions=\"['super_admin']\" ng-if=$ctrl.loggedIn> <md-icon>edit</md-icon> </md-button> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/hydromet/cms/cms.html
 ** module id = 313
 ** module chunks = 0
 **/